import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../data/content";
import { Eyebrow, Reveal } from "./Primitives";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
    <div className="grid gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>FAQ</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-ink sm:text-5xl">Frequently asked <span className="font-serif font-normal italic text-cobalt-700">questions.</span></h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible defaultValue="faq-0" className="border-t border-ink/10">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-ink/10">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg font-semibold text-ink hover:no-underline sm:text-xl">
                <span className="flex gap-5"><span className="font-mono text-[13px] font-normal text-ink/50">0{i + 1}</span>{f.q}</span>
              </AccordionTrigger>
              <AccordionContent className="pb-6 pl-0 sm:pl-11">
                <div className="space-y-3 text-[15px] leading-relaxed text-ink/70">{f.a.map((p) => <p key={p}>{p}</p>)}</div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
